export default {
  methods: {
    updateAMPTheme: function (key, value) {
      this.$store.commit('UPDATE_AMPTHEME', { key, value })
    },
    updateSettings: function (key, value) {
      this.$store.commit('UPDATE_SETTINGS', { key, value })
    }
  }
}
